function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M48 5.14v37.72C48 45.7 45.7 48 42.86 48H5.14A5.14 5.14 0 010 42.86V5.14C0 2.3 2.3 0 5.14 0h37.72C45.7 0 48 2.3 48 5.14zm-6.86 5.05c0-1.84-1.49-3.33-3.33-3.33H23.64a2.5 2.5 0 00-2.5 2.5v1.6a2.5 2.5 0 002.57 2.5l6-.18L7.5 35.35c-.84.83-.84 2.2 0 3.03l2.13 2.14c.84.83 2.2.83 3.03-.01l22.07-22.22-.17 6a2.5 2.5 0 002.5 2.57h1.6a2.5 2.5 0 002.5-2.5V10.19z",
  fillRule: "evenodd"
})));